<app-header></app-header>
<div class="login-container">
  <div class="logo">
    <img src="/images/logo-v2.png" alt="WealthLane" />
  </div>

  <h2><span>Créer</span> un compte</h2>

  <form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
    <div class="form-group">
      <label for="name">Prénom</label>
      <input type="text" formControlName="name" (input)="clearErrors()" />
    </div>
    <div class="error-message" *ngIf="submitted && registerForm.controls['name'].errors?.['required']">
      Prénom est requis
    </div>
    <div class="form-group">
      <label for="email">Email</label>
      <input type="email" formControlName="email" (input)="clearErrors()" />
    </div>
    <div class="error-message" *ngIf="submitted && registerForm.controls['email'].errors?.['required']">
      Email est requis
    </div>
    <div class="error-message" *ngIf="submitted && registerForm.controls['email'].errors?.['email']">
      Email est invalide
    </div>

    <div class="form-group">
      <label for="password">Mot de passe</label>
      <input type="password" formControlName="password" (input)="clearErrors()" />
    </div>
    <div class="error-message" *ngIf="submitted && registerForm.controls['password'].errors?.['required']">
      Mot de passe est requis
    </div>

    <div class="error-message" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <button type="submit" [disabled]="loading" class="submit-btn">Créer mon compte</button>

    <div class="separator">ou</div>

    <div class="google-auth-container">
      <button type="button" class="google-btn" (click)="loginWithGoogle()">
        S'inscrire avec Google
        <img src="/images/google-icn.png" alt="Google" />
      </button>
      <asl-google-signin-button type='standard' size='large' shape='pill' theme='outline'>
      </asl-google-signin-button>
    </div>

    <div class="signup-link">
      <a routerLink="/login">Déjà un compte ? Se connecter</a>
    </div>
  </form>
</div>
<app-footer></app-footer>